import React from "react";

interface SVGRProps {
  title?: string;
  titleId?: string;
}

export default function CrossIcon({
  title = "cross icon",
  titleId,
  ...props
}: React.SVGProps<SVGSVGElement> & SVGRProps) {
  return (
    <svg width="1em" height="1em" fill="none" aria-labelledby={titleId} {...props}>
      {title ? (
        <title id={titleId} className="localize-ignore">
          {title}
        </title>
      ) : null}
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.621 10.621l6.5 6.5L17.243 15l-6.5-6.5 6.378-6.379L15 0 8.621 6.379 2.243 0 .12 2.121 6.5 8.5 0 15l2.121 2.121 6.5-6.5z"
        fill="#000"
      />
    </svg>
  );
}

export function CrossIconLight({ ...props }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.292893 0.292893C0.683417 -0.0976311 1.31658 -0.0976311 1.70711 0.292893L7 5.58579L12.2929 0.292893C12.6834 -0.0976311 13.3166 -0.0976311 13.7071 0.292893C14.0976 0.683417 14.0976 1.31658 13.7071 1.70711L8.41421 7L13.7071 12.2929C14.0976 12.6834 14.0976 13.3166 13.7071 13.7071C13.3166 14.0976 12.6834 14.0976 12.2929 13.7071L7 8.41421L1.70711 13.7071C1.31658 14.0976 0.683417 14.0976 0.292893 13.7071C-0.0976311 13.3166 -0.0976311 12.6834 0.292893 12.2929L5.58579 7L0.292893 1.70711C-0.0976311 1.31658 -0.0976311 0.683417 0.292893 0.292893Z"
        fill={props.fill || "black"}
      />
    </svg>
  );
}
